<template>
    <div class="of-content5-category">
        <div class="cat-content-title">
            <span v-html="category.title"></span>
        </div>
        <div class="cat-content-items">
            <slot
                name="categoryItem"
                v-for="item in category.items"
                :item="item"
            ></slot>
        </div>
    </div>
</template>


<script>
    export default {
        name: "category",
        props: ["view"],
        components: {},
        methods: {},
        data() {
            return {
                title: "CATEGORY",
                items: [
                    { /* item1 */
                        mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-5/ic-training-card.svg',
                        title: "Marketing Afiliados",
                        text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                        button: {
                            text: "Learn more",
                            link: "#"
                        }
                    },
                    { /* item2 */
                        mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-5/ic-training-card.svg',
                        title: "Marketing Afiliados",
                        text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                        button: {
                            text: "Learn more",
                            link: "#"
                        }
                    },
                    { /* item3 */
                        mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-5/ic-training-card.svg',
                        title: "Marketing Afiliados",
                        text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                        button: {
                            text: "Learn more",
                            link: "#"
                        }
                    }
                ]
            }
        },
        computed: {
            category: function () {
                return (this.view !== undefined && this.view !== null) ? this.view : this.$data
            }
        },
        created() {},
        mounted() {}
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../../../../../scss/office";

	.of-content5-category {
        font: inherit;

        display: grid;
        grid-template-columns: 1fr 5fr; /* grid de 6fr */
        grid-template-rows: auto;
        column-gap: 2.7em; /* 27px */
        row-gap: 2.7em; /* 27px */
        justify-items: stretch;
        align-items: stretch;
        justify-content: stretch;
        align-content: stretch;

        .cat-content-title {
            font: inherit;

            background: $of-color1;
            border-radius: 0.4em; /* 4px */
            padding: 3em 0;

            display: flex;
            align-items: center;
            justify-content: center;
            span {
                font: inherit;
                font-size: 4.6em; /* 46px */
                font-weight: 700;
                line-height: 1.2;
                color: $of-color3;

                writing-mode: vertical-lr;
                text-orientation: sideways;
                transform: rotate(-180deg);
            }
        }

        .cat-content-items{
            font: inherit;

            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: repeat(1, auto);
            column-gap: 1.6em; /* 16px */
            row-gap: 1.6em; /* 16px */
            justify-items: stretch;
            align-items: stretch;
            justify-content: stretch;
            align-content: stretch;
        }
    }
    
    @media (max-width: 768px) { /* smartphones e tablets*/
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-5/category.vue